// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2020-09-29 20:52:57 +0200 (Tue, 29 Sep 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 113830 $
//  Purpose   : mods package
// =============================================================================
export const parts = true

export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

import * as views from './views'
export {views}
